<template>
  <div>
    <el-form :model="queryForm" :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="协议编号" prop="protocolId">
            <el-input type="text" v-model="queryForm.protocolId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协议下载" prop="isDownload">
            <el-select v-model="queryForm.isDownload" size="small" clearable>
              <el-option :value="1" label="有"></el-option>
              <el-option :value="0" label="无"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <SearchButton @search="search" @reset="resetSearchForm" @expand="e => expand = e"></SearchButton>
        </el-col>
      </el-row>
      <el-row v-if="expand">
        <el-col :span="6">
          <el-form-item label="生成时间" prop="createTimeRange">
            <DateRangePicker v-model="queryForm.createTimeRange"></DateRangePicker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协议标题" prop="protocolTitle">
            <el-input type="text" v-model="queryForm.protocolTitle" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协议状态" prop="protocolProgress">
            <DictionarySelect v-model="queryForm.protocolProgress" :lazy="true" tableCode="PROTOCOL_PROGRESS"></DictionarySelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="总救助费用" prop="totalHelpAmountRange">
            <NumberRange v-model="queryForm.totalHelpAmountRange" dataType="money"></NumberRange>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="expand">
        <el-col :span="6">
          <el-form-item label="是否汇款" prop="isRemit">
            <el-select v-model="queryForm.isRemit" size="small" clearable>
              <el-option :value="1" label="是"></el-option>
              <el-option :value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="汇款时间" prop="remitTimeRange">
            <DateRangePicker v-model="queryForm.remitTimeRange"></DateRangePicker>
          </el-form-item>
        </el-col>
        <!--<el-col :span="6" v-if="!isHospitalRole">
          <el-form-item label="救助医院" prop="hospitalId">
            <HospitalSelect v-model="queryForm.hospitalId"></HospitalSelect>
          </el-form-item>
        </el-col>-->
      </el-row>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      height='calc(100vh - 241px)'>
      <el-table-column prop="protocolId" label="协议编号" width="170">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.protocolId">
            <span class="link" @click="toDetail(scope.row)">{{ scope.row.protocolId }}</span>
          </TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="protocolTitle" label="协议标题">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.protocolTitle"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="settlementMethodName" width="110" label="结算方式">
        <template slot-scope="scope">
          <span v-if="scope.row.settlementMethod=='4'"></span>
          <span v-else>{{scope.row.settlementMethodName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" width="110" label="生成时间">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="hospitalName" label="救助医院">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
        </template>
      </el-table-column> -->
      <el-table-column prop="batchNo" width="70" label="批次"></el-table-column>
      <el-table-column prop="childSum" width="80" label="患儿人数" align="left"></el-table-column>
      <el-table-column prop="totalHelpAmount" width="110" label="总救助费用" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.totalHelpAmount ? parseFloat(scope.row.totalHelpAmount).toFixed(2) : '-' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="protocolTypeName" width="80" label="协议类型"></el-table-column> -->
      <el-table-column prop="progressCodeName" width="80" label="协议状态">
        <template slot-scope="scope">
          <span>{{ scope.row.nodeCode == 99 ? '已清退' : scope.row.progressCodeName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="isRemit" label="是否汇款"></el-table-column> -->
      <el-table-column prop="remitTime" width="100" label="汇款时间">
        <template slot-scope="scope">
          <span>{{ scope.row.remitTime ? parseTime(scope.row.remitTime, '{y}-{m}-{d}') : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="receivedBillTime" width="100" label="发票时间">
        <template slot-scope="scope">
          <span>{{ scope.row.receivedBillTime ? parseTime(scope.row.receivedBillTime, '{y}-{m}-{d}') : '-' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="isBankReceipt" width="80" label="有无回单">
        <template slot-scope="scope">
          <span v-if="scope.row.isBankReceipt == 1">有</span>
          <span v-else-if="scope.row.isBankReceipt == 0">无</span>
          <span v-else>-</span>
        </template>
      </el-table-column> -->
      <el-table-column width="110" fixed="right" label="协议下载">
        <template slot-scope="scope">
          <el-button v-if="scope.row.nodeCode > 2 && scope.row.nodeCode != 99 && scope.row.downloadEnable == 1 && scope.row.downloadType==0" type="primary" size="mini" plain @click="downloadProtocol(scope.row)">协议下载</el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column width="110" fixed="right" label="结算单下载">
        <template slot-scope="scope">
          <el-button v-if="scope.row.nodeCode > 2 && scope.row.nodeCode != 99 && scope.row.downloadEnable == 1 && scope.row.downloadType==1 
            && scope.row.settlementMethod!='1' && scope.row.settlementMethod!='4' " type="primary" size="mini" plain @click="downloadProtocolJS(scope.row)">结算单下载</el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <Pageination
      @sizeChange="handleSizeChange"
      @currentChange="handleCurrentChange"
      :currentPage="queryParams.pageNO"
      :total="pageTotal">
    </Pageination>
  </div>
</template>

<script>
import { getProtocolDataListByCond, downloadProtocol, downFileApi, getFileListByIds,downloadProtocolJS } from "@/util/api.js";
import HospitalSelect from "@/components/business/HospitalSelect";
import DateRangePicker from "@/components/business/DateRangePicker";
import NumberRange from "@/components/business/NumberRange";
import NumberInput from "@/components/business/NumberInput";
import DictionarySelect from "@/components/business/DictionarySelect";
import SearchButton from "@/components/business/SearchButton";
import Pageination from "@/components/business/Pageination";
import TableCellWordBreak from "@/components/business/TableCellWordBreak"

export default {
  components: {
    HospitalSelect,
    DateRangePicker,
    NumberRange,
    NumberInput,
    DictionarySelect,
    SearchButton,
    Pageination,
    TableCellWordBreak
  },
  data() {
    let isHospitalRole = this.isHospital();
    return {
      isHospitalRole: isHospitalRole,
      loading: false,
      expand: false,
      queryForm: {},
      queryParams: {
        pageNO: 1,
        pageSize: 10,
        searchCond: {}
      },
      tableData: [],
      pageTotal: 0
    };
  },
  mounted () {
    this.queryParams.pageNO = 1;
    this.loadData();
  },
  methods: {
    search () {
      this.queryParams.pageNO = 1;
      this.loadData();
    },
    loadData () {
      this.loading = true
      if (this.queryForm.createTimeRange && this.queryForm.createTimeRange.length > 1) {
        this.queryForm.createTimeBegin = this.queryForm.createTimeRange[0];
        this.queryForm.createTimeEnd = this.queryForm.createTimeRange[1];
      } else {
        this.queryForm.helpTimeBegin = null;
        this.queryForm.helpTimeEnd = null;
      }
      if (this.queryForm.remitTimeRange && this.queryForm.remitTimeRange.length > 1) {
        this.queryForm.remitTimeBegin = this.queryForm.remitTimeRange[0];
        this.queryForm.remitTimeEnd = this.queryForm.remitTimeRange[1];
      } else {
        this.queryForm.remitTimeBegin = null;
        this.queryForm.remitTimeEnd = null;
      }
      if (this.queryForm.childCountRange && this.queryForm.childCountRange.length > 1) {
        this.queryForm.childCountBegin = this.queryForm.childCountRange[0];
        this.queryForm.childCountEnd = this.queryForm.childCountRange[1];
      } else {
        this.queryForm.childCountBegin = null;
        this.queryForm.childCountEnd = null;
      }
      if (this.queryForm.totalHelpAmountRange && this.queryForm.totalHelpAmountRange.length > 1) {
        this.queryForm.totalHelpAmountBegin = this.queryForm.totalHelpAmountRange[0];
        this.queryForm.totalHelpAmountEnd = this.queryForm.totalHelpAmountRange[1];
      } else {
        this.queryForm.totalHelpAmountBegin = null;
        this.queryForm.totalHelpAmountEnd = null;
      }
      this.queryParams.searchCond = Object.assign({}, this.queryForm);
      this.queryParams.searchCond.applyType = 1;
      getProtocolDataListByCond(this.queryParams).then(res => {
        this.tableData = res.responseData.modelData;
        this.pageTotal = res.responseData.total;
        this.loading = false
      })
    },
    downloadProtocol (row) {
      // if (row.scanCopy) {
      //   getFileListByIds([row.scanCopy]).then(res => {
      //     if (res.responseData && res.responseData.length > 0) {
      //       let file = res.responseData[0];
      //       let link = document.createElement('a');
      //       link.style.display = 'none';
      //       link.setAttribute('target', '_blank');
      //       link.href = file.fileUrl;
      //       link.setAttribute('download', row.protocolTitle + file.fileName);
      //       document.body.appendChild(link);
      //       link.click();
      //     }
      //   })
      // } else {
        downloadProtocol(row.protocolId).then(data => {
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', row.protocolTitle + '.pdf');
          document.body.appendChild(link);
          link.click();
        })
      // }
    },

    /**
     * 协议结算单下载
     */
    downloadProtocolJS(row){
      downloadProtocolJS(row.protocolId).then(data => {
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', row.protocolTitle + '结算单.pdf');
        document.body.appendChild(link);
        link.click();
      })
    },
    resetSearchForm() {
      this.queryForm = {};
      this.queryParams.pageNO = 1;
      this.loadData();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNO = val
      this.loadData()
    },
    openScreenFun() {
      this.openScreen1 = !this.openScreen1;
    },
    toDetail(row) {
      this.$router.push("/protocol/detail/" + row.protocolId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
</style>



// WEBPACK FOOTER //
// src/pages/protocol/manage/ProtocolManageTable.vue